"use client";

import { Link } from "@/components/ui";
import { Title, Button, Subtitle } from "@tremor/react";
import Image from "next/image";
import { useRouter } from "next/navigation";
export default function NotFound() {
  const router = useRouter();
  return <div className="flex flex-col items-center justify-center h-full" data-sentry-component="NotFound" data-sentry-source-file="not-found.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="not-found.tsx">404 Page not found</Title>
      <Subtitle data-sentry-element="Subtitle" data-sentry-source-file="not-found.tsx">
        If you believe this is an error, please contact us on{" "}
        <Link href="https://slack.keephq.dev/" target="_blank" rel="noopener noreferrer" data-sentry-element="Link" data-sentry-source-file="not-found.tsx">
          Slack
        </Link>
      </Subtitle>
      <Image src="/keep.svg" alt="Keep" width={150} height={150} data-sentry-element="Image" data-sentry-source-file="not-found.tsx" />
      <Button onClick={() => {
      router.back();
    }} color="orange" variant="secondary" data-sentry-element="Button" data-sentry-source-file="not-found.tsx">
        Go back
      </Button>
    </div>;
}